import { getAuth0Audience, getAppUrl, getAuth0ClientId, getAuth0Domain } from './config/env';

// dynamically detect the current environment
const getCurrentOrigin = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  // default value, for SSR
  return getAppUrl() ?? 'http://localhost:9000';
};

const auth0Domain = getAuth0Domain();

export const auth0Config = {
  domain: auth0Domain ?? '',
  clientId: getAuth0ClientId() ?? '',
  authorizationParams: {
    redirect_uri: `${getCurrentOrigin()}/callback`,
    audience: getAuth0Audience(),
    // Force upstream IdPs (e.g., Google) to always show account chooser
    prompt: 'select_account' as const,
  },
  cacheLocation: 'localstorage' as const,
  useRefreshTokens: true,
  // Simplified onRedirectCallback - most logic moved to LoginCallback component
  onRedirectCallback: (appState: any) => {
    console.log('Auth0 redirect callback - appState:', appState);
    // The LoginCallback component will handle the post-login logic
    // No need to do anything here as the component will be rendered
  },
  // Force new authentication flow
  skipRedirectCallback: false,
};
